/* ===========================
   LB Addons + Skio-safe ATC text updater
   - Same functionality as your current script
   - Fixes 429/rate-limit risk by removing full-document MutationObserver
   - Adds Safari “click on text does nothing” fix (forward span tap to button)
   =========================== */

(() => {
  let attempt = 0;
  const maxAttempts = 5;

  // ====== SELECTORS ======
  const ATC_TEXT_SEL = '#dynamic-add-to-cart-text';

  // Skio
  const SUB_PRICE_SEL = 'span[skio-subscription-price]';
  const ONE_TIME_SEL  = 'span[skio-onetime-price]';
  const SELLING_PLAN_SEL = 'input[name="selling_plan"]';
  const SKIO_ANCHOR_SEL = '.skio-group-content';

  // Quantity (your DOM)
  const QTY_INPUT_SEL = 'quantity-input input[name="quantity"]';

  // ====== INIT POLL (.lb-embed) ======
const tryInitialize = () => {
  const hasProductContext =
    !!document.querySelector(ATC_TEXT_SEL) ||
    !!document.querySelector('product-form') ||
    !!document.querySelector('form[action*="/cart/add"]');

  if (hasProductContext) {
    console.log('Product context found. Initializing price sync...');
    initializeAddonLogic();
    return;
  }

  attempt++;
  if (attempt < maxAttempts) {
    setTimeout(tryInitialize, 1000);
  } else {
    console.log('Product context not found after 5 attempts. Script aborted.');
  }
};

  const initializeAddonLogic = () => {
    // Prevent double-init if the script is injected twice
    if (window.__lbAddonPriceSyncInitialized) return;
    window.__lbAddonPriceSyncInitialized = true;

    let cachedATCBasePrice = null;  // fallback base (no Skio)
    let lastMode = null;            // "subscription" | "onetime"
    let lastUnitPrice = null;       // per-unit base price
    let lastQty = 1;

    // ---- utilities ----
    function extractPriceFromText(text) {
      const match = (text || '').trim().match(/([\d.,]+)/);
      return match ? parseFloat(match[1].replace(/,/g, '')) : 0;
    }

    function formatMoney(num) {
      return `$${Number(num || 0).toFixed(2)}`;
    }

    function getATCEl() {
      return document.querySelector(ATC_TEXT_SEL);
    }

    function getQty() {
      const qtyEl = document.querySelector(QTY_INPUT_SEL);
      const val = qtyEl ? parseInt(qtyEl.value || '1', 10) : 1;
      return isNaN(val) || val < 1 ? 1 : val;
    }

    function hasSkioBox() {
      return (
        !!document.querySelector(SKIO_ANCHOR_SEL) ||
        !!document.querySelector(SUB_PRICE_SEL) ||
        !!document.querySelector(ONE_TIME_SEL) ||
        !!document.querySelector(SELLING_PLAN_SEL)
      );
    }

    function readSkioState() {
      const spEl = document.querySelector(SELLING_PLAN_SEL);
      const subEl = document.querySelector(SUB_PRICE_SEL);
      const oneEl = document.querySelector(ONE_TIME_SEL);

      const sellingPlanVal = (spEl?.value || '').trim();
      const mode = sellingPlanVal ? 'subscription' : 'onetime';

      const subText = (subEl?.textContent || '').trim();
      const oneText = (oneEl?.textContent || '').trim();

      const chosenText = mode === 'subscription'
        ? (subText || oneText)
        : (oneText || subText);

      const chosenNum = extractPriceFromText(chosenText);

      return { mode, chosenText, chosenNum, hasAny: !!(subText || oneText) };
    }

    // IMPORTANT FIX:
    // When Skio is present, treat the Skio price spans as UNIT price,
    // then multiply by quantity.
    function getUnitBasePrice() {
      if (hasSkioBox()) {
        const sk = readSkioState();
        if (sk.hasAny && sk.chosenNum > 0) {
          lastMode = sk.mode;
          lastUnitPrice = sk.chosenNum;
          return sk.chosenNum;
        }
      }

      // No Skio: fallback to parsing ATC once as unit price
      if (cachedATCBasePrice !== null) return cachedATCBasePrice;

      const atc = getATCEl();
      if (!atc) return 0;

      const parsed = extractPriceFromText(atc.textContent);
      cachedATCBasePrice = parsed;
      lastUnitPrice = parsed;
      return parsed;
    }

    function syncExtraSubscriptionBadge() {
      const badgesWrap = document.querySelector('.f-product-single__blocks .f-price__badges');
      if (!badgesWrap) return;

      const existingExtraBadge = badgesWrap.querySelector('.f-price__badge-extra-sub');

      const checkedRadio = document.querySelector('input[type="radio"]:checked');
      let isSubscription = false;

      if (checkedRadio) {
        const optionCard =
          checkedRadio.closest('label') ||
          checkedRadio.parentElement;

        const optionText = optionCard ? optionCard.textContent.toLowerCase() : '';
        isSubscription = optionText.includes('subscribe');
      }

      if (isSubscription) {
        if (!existingExtraBadge) {
          const extraBadgeWrap = document.createElement('div');
          extraBadgeWrap.className = 'f-price__badge-extra-sub';
          extraBadgeWrap.innerHTML = '<span class="f-badge f-badge--sale">+ EXTRA 15% OFF</span>';
          badgesWrap.appendChild(extraBadgeWrap);
        }
      } else {
        if (existingExtraBadge) {
          existingExtraBadge.remove();
        }
      }
    }

    function syncMainPriceForSubscription(mode) {
      const mainPrice = document.querySelector('.f-product-single__blocks .f-price');
      if (!mainPrice) return;

      const oneTimeEl = document.querySelector(ONE_TIME_SEL);
      const oneTimeText = (oneTimeEl?.textContent || '').trim();

      const removeSyntheticCompareNodes = () => {
        mainPrice
          .querySelectorAll('.f-price__sale [data-subscription-compare="true"]')
          .forEach((node) => node.remove());
      };

      const clearSyntheticCompare = () => {
        if (mainPrice.dataset.subscriptionCompare !== 'true') return;

        mainPrice.classList.remove('f-price--on-sale');
        delete mainPrice.dataset.subscriptionCompare;
        removeSyntheticCompareNodes();

        const compareItem = mainPrice.querySelector(
          '.f-price__sale s.f-price-item--regular'
        );
        if (compareItem) compareItem.textContent = '';

        const regularItem = mainPrice.querySelector(
          '.f-price__regular .f-price-item--regular'
        );
        if (regularItem && oneTimeText) {
          regularItem.textContent = oneTimeText;
        }
      };

      if (mode !== 'subscription' || !oneTimeText) {
        clearSyntheticCompare();
        return;
      }

      // Real theme sale already renders compare-at at the top via Liquid.
      const isRealSale =
        mainPrice.classList.contains('f-price--on-sale') &&
        mainPrice.dataset.subscriptionCompare !== 'true';
      if (isRealSale) return;

      mainPrice.dataset.subscriptionCompare = 'true';
      mainPrice.classList.add('f-price--on-sale');

      const saleWrap = mainPrice.querySelector('.f-price__sale');
      const saleItem = saleWrap?.querySelector('.f-price-item--sale');
      if (!saleWrap || !saleItem) return;

      removeSyntheticCompareNodes();

      let compareWrap = saleWrap.querySelector('span[data-subscription-compare="true"]');
      let compareItem = saleWrap.querySelector('s.f-price-item--regular');

      if (!compareWrap) {
        if (compareItem) {
          compareWrap = compareItem.closest('span') || compareItem;
        } else {
          compareWrap = document.createElement('span');
          compareWrap.dataset.subscriptionCompare = 'true';
          compareWrap.innerHTML =
            '<s class="f-price-item f-price-item--regular"></s>';
          compareItem = compareWrap.querySelector('s');
        }
      }

      compareWrap.dataset.subscriptionCompare = 'true';
      compareItem = compareWrap.querySelector('s') || compareItem;
      if (compareItem) compareItem.textContent = oneTimeText;

      // Match Skio row: compare-at first, subscription price second.
      saleWrap.insertBefore(compareWrap, saleItem);
    }

    // `total` (button label) is unit price x quantity, plus any checked
    // add-ons - the full amount this add will actually cost. `unitPrice`
    // (top-of-page price display) is the plain per-unit price for the
    // chosen purchase type only - it should never move with quantity or
    // add-on selection, only with one-time vs subscription.
    function setATCText(total, unitPrice) {
      const atc = getATCEl();
      if (!atc) return;

      const sk = hasSkioBox() ? readSkioState() : { mode: 'onetime' };
      syncMainPriceForSubscription(sk.mode);

      atc.textContent = `ADD TO BAG – ${formatMoney(total)}`;

      // Keep original PDP price behavior untouched:
      // just update whichever price element already exists
      const saleEl = document.querySelector('.f-product-single__blocks .f-price-item.f-price-item--sale');
      const regularEl = document.querySelector('.f-product-single__blocks .f-price__regular .f-price-item--regular');

      if (saleEl) {
        saleEl.textContent = formatMoney(unitPrice);
      } else if (regularEl) {
        regularEl.textContent = formatMoney(unitPrice);
      }

      // Only manage the extra top subscription badge
      syncExtraSubscriptionBadge();
    }

    function updateCartText() {
      const qty = getQty();
      lastQty = qty;

      const unit = getUnitBasePrice();
      let total = unit * qty;

      total += getAddonsTotal();

      setATCText(total, unit);
    }

    // ====== scheduler (same as yours) ======
    const scheduleUpdate = (() => {
      let queued = false;
      return () => {
        if (queued) return;
        queued = true;
        queueMicrotask(() => {
          requestAnimationFrame(() => {
            queued = false;
            updateCartText();
          });
        });
      };
    })();

    // ---- Addon logic ----
    // Reads each checked add-on fresh from the live DOM on every update
    // rather than tracking selection in a card -> state map. The add-on
    // widget (e.g. Selleasy's "Pairs Well With") re-renders its own cards
    // independently of anything here - we've seen it replace a card's DOM
    // entirely (new element, fresh unchecked state) after unrelated cart
    // activity, which would silently orphan a map keyed by node
    // references. Recomputing from scratch is cheap and can't go stale.
    // (Selection used to be read via an `lb-selected` attribute the
    // widget doesn't actually set - the checkbox's own `checked` state is
    // the real source of truth, confirmed against the live widget.)
    function getAddonCards() {
      return document.querySelectorAll('.lb-flat-card-host, .lb-product-card');
    }

    function isAddonSelected(card) {
      const checkbox = card.querySelector('input[type="checkbox"]');
      return !!(checkbox && checkbox.checked);
    }

    function getAddonPrice(card) {
      const priceSpan = card.querySelector('span.lb-price-sale-price.money');
      const priceText = priceSpan ? priceSpan.textContent.trim().replace('$', '') : null;
      return priceText ? parseFloat(priceText) : 0;
    }

    function getAddonQuantity(card) {
      const qtyEl = card.querySelector('.lb-qty-count');
      if (!qtyEl) return 1;

      let val = qtyEl.valueAsNumber;

      if (isNaN(val) || val < 1) {
        val = parseInt(qtyEl.getAttribute('value') || '', 10);
      }

      if (isNaN(val) || val < 1) {
        const alt = qtyEl.textContent?.trim();
        val = parseInt(alt || '', 10);
      }

      return isNaN(val) || val < 1 ? 1 : val;
    }

    function getAddonsTotal() {
      let total = 0;
      getAddonCards().forEach((card) => {
        if (!isAddonSelected(card)) return;
        total += getAddonPrice(card) * getAddonQuantity(card);
      });
      return total;
    }

    // Re-run the price total whenever a checkbox or an add-on's own
    // quantity stepper is used - delegated at the document level so this
    // keeps working no matter how many times the widget re-renders its
    // cards (a listener bound to a specific card node would go dead the
    // moment that node gets replaced).
    document.addEventListener('change', (e) => {
      if (e.target.closest && e.target.closest('.lb-flat-card-host, .lb-product-card')) {
        scheduleUpdate();
      }
    }, true);

    document.addEventListener('click', (e) => {
      if (
        e.target.closest &&
        e.target.closest('.lb-qty-add, .lb-qty-remove, .lb-card-checkbox, .lb-checkbox-cont')
      ) {
        // The widget updates its own DOM asynchronously after a tap, so
        // give it a beat before re-reading price/quantity.
        setTimeout(scheduleUpdate, 50);
      }
    }, true);

    // ====== PRODUCT QUANTITY LISTENER (delegated, same idea) ======
    document.addEventListener('input', (e) => {
      const t = e.target;
      if (t && t.matches(QTY_INPUT_SEL)) scheduleUpdate();
    }, true);

    document.addEventListener('change', (e) => {
      const t = e.target;
      if (t && t.matches(QTY_INPUT_SEL)) scheduleUpdate();
    }, true);

    document.addEventListener('click', (e) => {
      const btn = e.target.closest('quantity-input button[name="plus"], quantity-input button[name="minus"]');
      if (btn) scheduleUpdate();
    }, true);

    // Also observe the quantity input value attribute
    const attachQtyObserver = () => {
      const qtyEl = document.querySelector(QTY_INPUT_SEL);
      if (!qtyEl) return false;

      const qtyObs = new MutationObserver(() => scheduleUpdate());
      qtyObs.observe(qtyEl, { attributes: true, attributeFilter: ['value'] });
      return true;
    };

    let qtyTries = 0;
    const qtyPoll = setInterval(() => {
      qtyTries++;
      if (attachQtyObserver()) clearInterval(qtyPoll);
      if (qtyTries > 200) clearInterval(qtyPoll);
    }, 100);

    // ====== Skio observers (same, but no runaway polling) ======
    const attachSkioObservers = () => {
      const spEl = document.querySelector(SELLING_PLAN_SEL);
      const subEl = document.querySelector(SUB_PRICE_SEL);
      const oneEl = document.querySelector(ONE_TIME_SEL);

      if (!spEl && !subEl && !oneEl) return false;

      if (spEl) {
        const spObserver = new MutationObserver(() => scheduleUpdate());
        spObserver.observe(spEl, { attributes: true, attributeFilter: ['value'] });

        // Keep your value polling, but slower to reduce churn
        let last = spEl.value;
        const int = setInterval(() => {
          const cur = spEl.value;
          if (cur !== last) {
            last = cur;
            scheduleUpdate();
          }
        }, 300);

        // store so it can be cleared if needed later
        window.__lbSkioPlanPoll = int;
      }

      const priceObserver = new MutationObserver(() => scheduleUpdate());
      if (subEl) priceObserver.observe(subEl, { childList: true, subtree: true, characterData: true });
      if (oneEl) priceObserver.observe(oneEl, { childList: true, subtree: true, characterData: true });

      return true;
    };

    let skioTries = 0;
    const skioPoll = setInterval(() => {
      skioTries++;
      if (attachSkioObservers()) {
        clearInterval(skioPoll);
        scheduleUpdate();
      }
      if (skioTries > 200) clearInterval(skioPoll);
    }, 100);

    // ====== CRITICAL CHANGE: remove full-document observer ======
    // Instead observe only relevant containers and throttle callback.
    const observeRelevantDOM = () => {
      const targets = [
        document.querySelector('.lb-embed'),
        document.querySelector(SKIO_ANCHOR_SEL),
        document.querySelector('product-form'),
        document.querySelector('form[action*="/cart/add"]')
      ].filter(Boolean);

      if (!targets.length) return false;

      let lastRun = 0;
      const THROTTLE_MS = 250;

      const domObserver = new MutationObserver(() => {
        const now = Date.now();
        if (now - lastRun < THROTTLE_MS) return;
        lastRun = now;
        scheduleUpdate();
      });

      targets.forEach(t => domObserver.observe(t, { childList: true, subtree: true, attributes: true }));
      return true;
    };

    let domTries = 0;
    const domPoll = setInterval(() => {
      domTries++;
      if (observeRelevantDOM()) clearInterval(domPoll);
      if (domTries > 60) clearInterval(domPoll);
    }, 250);

    // Initial capture
    if (!hasSkioBox()) getUnitBasePrice();
    scheduleUpdate();

    // ====== Safari fix: clicking on #dynamic-add-to-cart-text should always submit ======
    // BUT: only do it for that specific span.
    (function attachSafariForwarder(){
      const SPAN_SEL = ATC_TEXT_SEL;

      function forwardToButton(e) {
        const span = e.target && (e.target.matches?.(SPAN_SEL) ? e.target : e.target.closest?.(SPAN_SEL));
        if (!span) return;

        const btn = span.closest('button[type="submit"], button[name="add"], button');
        if (!btn) return;

        const form = btn.closest('form');

        e.preventDefault();
        e.stopPropagation();

        if (form && typeof form.requestSubmit === 'function') {
          form.requestSubmit(btn);
        } else {
          btn.click();
        }
      }

      document.addEventListener('click', forwardToButton, true);
      document.addEventListener('touchend', forwardToButton, { capture: true, passive: false });
    })();
  };

  tryInitialize();
})();





(() => {
  // ---- helpers ----
  const normalizeProto = (video) => {
    [...video.querySelectorAll('source')].forEach(s => {
      if (s.src && s.src.startsWith('//')) s.src = 'https:' + s.src;
    });
    if (video.poster && video.poster.startsWith('//')) video.poster = 'https:' + video.poster;
  };

  const hoverControls = (video) => {
    // Hide initially
    video.removeAttribute('controls');

    // Desktop: show on hover
    const onEnter = () => video.setAttribute('controls', 'controls');
    const onLeave = () => video.removeAttribute('controls');
    video.addEventListener('mouseenter', onEnter);
    video.addEventListener('mouseleave', onLeave);

    // Mobile: show on first tap for 3s, then hide
    const onTouch = () => {
      video.setAttribute('controls', 'controls');
      clearTimeout(video._controlsTimer);
      video._controlsTimer = setTimeout(() => video.removeAttribute('controls'), 3000);
    };
    video.addEventListener('touchstart', onTouch, {passive: true});
  };

  const prepAndPlay = (video) => {
    if (!video) return;
    normalizeProto(video);
    video.muted = true;
    video.loop = true;
    video.autoplay = true;
    video.playsInline = true;

    hoverControls(video);

    // Give lazy render a tick, then play
    setTimeout(() => {
      const p = video.play?.();
      if (p && typeof p.then === 'function') {
        p.then(() => console.log('✅ Playing:', video))
         .catch(err => console.warn('⚠️ Autoplay blocked:', err));
      }
    }, 100);
  };

  const waitForVideoIn = (root, timeout = 5000) =>
    new Promise((resolve, reject) => {
      const existing = root.querySelector('video:not(template video)');
      if (existing) return resolve(existing);

      const obs = new MutationObserver(() => {
        const v = root.querySelector('video:not(template video)');
        if (v) { obs.disconnect(); resolve(v); }
      });
      obs.observe(root, {childList: true, subtree: true});
      setTimeout(() => { obs.disconnect(); reject(new Error('Timed out waiting for video')); }, timeout);
    });

  const bootOneDeferred = async (dm) => {
    try {
      let video = dm.querySelector('video:not(template video)');
      if (!video) dm.querySelector('.deferred-media__poster')?.click();
      video = await waitForVideoIn(dm, 6000);
      prepAndPlay(video);
    } catch (e) {
      console.warn('⚠️ Could not start a deferred-media video:', e);
    }
  };

  // ---- run once for existing blocks ----
  const blocks = document.querySelectorAll('.f-product__media.f-product__media--video deferred-media');
  if (!blocks.length) {
    console.log('ℹ️ No deferred-media found yet; watching for future mounts...');
  } else {
    blocks.forEach(bootOneDeferred);
  }

  // ---- also watch for future product media (variant/slider changes) ----
  const pageObs = new MutationObserver((muts) => {
    muts.forEach(m => {
      m.addedNodes && [...m.addedNodes].forEach(node => {
        if (!(node instanceof Element)) return;
        // If a new deferred-media or video appears, handle it
        if (node.matches?.('deferred-media')) bootOneDeferred(node);
        node.querySelectorAll?.('deferred-media').forEach(bootOneDeferred);
        node.querySelectorAll?.('.f-product__media video').forEach(prepAndPlay);
      });
    });
  });
  pageObs.observe(document.documentElement, {childList: true, subtree: true});

  // Also handle any already-mounted <video> that aren’t in deferred-media
  document.querySelectorAll('.f-product__media video').forEach(prepAndPlay);
})();





(function () {
  if (window.innerWidth > 600) return;

  const section = document.querySelector(
    'section.custom-video-section.container .custom-video-wrapper'
  );
  const target = document.querySelector(
    'section.custom-video-section.container .custom-video-content span'
  );

  if (!section || !target) return;

  target.parentNode.insertBefore(section, target);
})();






(function () {
  // ✅ Prevent multiple initializations (theme re-renders cart HTML a lot)
  if (window.__drawerCartSyncInitialized) return;
  window.__drawerCartSyncInitialized = true;

  const drawer = document.querySelector('drawer-component#Drawer-Cart');
  if (!drawer) {
    console.warn('Drawer-Cart not found');
    return;
  }

  const getDrawerSpans = () =>
    Array.from(document.querySelectorAll('h2#cart-drawer-title span[data-type="drawer"]'));

  const getDrawerCountText = () => {
    const spans = getDrawerSpans();
    if (spans.length < 2) return '';
    return (spans[1].textContent || '').trim();
  };

  const syncDrawerTitleCount = () => {
    const spans = getDrawerSpans();
    if (spans.length < 2) return;

    const first = spans[0];
    const second = spans[1];
    const newText = (second.textContent || '').trim();
    if (!newText) return;

    if ((first.textContent || '').trim() !== newText) {
      first.textContent = newText;
      console.log('[Drawer] Synced drawer title count:', newText);
    }
  };

  const syncCartBubbleToDrawer = () => {
    const bubble = document.querySelector('.cart-link__count');
    const numberEl = bubble?.querySelector('span[data-cart-count-number]');
    if (!bubble || !numberEl) return;

    const drawerText = getDrawerCountText();
    if (!drawerText) return;

    const next = parseInt(drawerText.replace(/[^\d]/g, ''), 10);
    if (Number.isNaN(next)) return;

    const current = parseInt((numberEl.textContent || '0').trim(), 10) || 0;
    if (current !== next) {
      numberEl.textContent = String(next);
      if (next > 0) bubble.classList.remove('is-cart-empty');
      if (next === 0) bubble.classList.add('is-cart-empty');
      console.log('[Drawer] Synced cart bubble to:', next);
    }
  };

  // ✅ Only do the cart goal clone once per page (even if cart re-renders)
  const copyCartGoalSecondToFirstOncePerPage = () => {
    if (window.__drawerCartGoalCloned) return;

    const goals = Array.from(document.querySelectorAll('f-cart-goal.f-cartgoal.f-cartgoal__drawer'));
    if (goals.length < 2) return;

    const first = goals[0];
    const second = goals[1];

    const clone = second.cloneNode(true);
    first.replaceWith(clone);

    window.__drawerCartGoalCloned = true;
    console.log('[Drawer] Replaced first cart goal with clone of second (once per page)');
  };

  // Run a few times after open to catch async updates, but don’t stack endlessly
  let openTick = 0;
  const syncOnOpen = () => {
    openTick++;
    syncDrawerTitleCount();
    syncCartBubbleToDrawer();
    copyCartGoalSecondToFirstOncePerPage();
    console.log('[Drawer] sync pass:', openTick);
  };

  const observer = new MutationObserver((mutations) => {
    for (const m of mutations) {
      if (m.type === 'attributes' && m.attributeName === 'open') {
        if (drawer.hasAttribute('open')) {
          console.log('[Drawer] OPENED');
          openTick = 0;

          syncOnOpen();
          requestAnimationFrame(syncOnOpen);
          setTimeout(syncOnOpen, 50);
          setTimeout(syncOnOpen, 200);
        } else {
          console.log('[Drawer] CLOSED');
        }
      }
    }
  });

  observer.observe(drawer, { attributes: true, attributeFilter: ['open'] });
  console.log('[Drawer] Listener attached (single init)');
})();





/* skio*/

(function () {
  const SELLING_PLAN_SELECTOR = 'input[name="selling_plan"]';
  const INSERT_AFTER_SELECTOR = '.skio-group-content';
  const INJECT_ID = 'subscribe-benefits-injected';
  const SUBS_CLASS = 'subs_open';

  const injectedHTML = `
    <div id="${INJECT_ID}" class="subscribe-benefits" style="margin-top:12px;">
      <ul style="list-style:none; padding:0; margin:0; display:flex; flex-direction:column; gap:6px;">
        <li style="display:flex; align-items:flex-start; gap:10px;">
          <span aria-hidden="true" style="font-weight:700; line-height:1;">✓</span>
          <span>Easily modify, cancel or pause</span>
        </li>
        <li style="display:flex; align-items:flex-start; gap:10px;">
          <span aria-hidden="true" style="font-weight:700; line-height:1;">✓</span>
          <span>Free shipping &amp; fast delivery time</span>
        </li>
        <li style="display:flex; align-items:flex-start; gap:10px;">
          <span aria-hidden="true" style="font-weight:700; line-height:1;">✓</span>
          <span>A smarter path to long-term results</span>
        </li>
      </ul>
    </div>
  `;

  const getSellingPlanInput = () => document.querySelector(SELLING_PLAN_SELECTOR);
  const getInsertAfterEl = () => document.querySelector(INSERT_AFTER_SELECTOR);
  const getInjected = () => document.getElementById(INJECT_ID);

  const hasSellingPlanValue = () => {
    const el = getSellingPlanInput();
    return !!(el && String(el.value || '').trim());
  };

  const addSubsClass = () => {
    const el = getInsertAfterEl();
    if (el) el.classList.add(SUBS_CLASS);
  };

  const removeSubsClass = () => {
    const el = getInsertAfterEl();
    if (el) el.classList.remove(SUBS_CLASS);
  };

  const injectIfNeeded = () => {
    if (getInjected()) return;
    const anchor = getInsertAfterEl();
    if (!anchor) return;
    anchor.insertAdjacentHTML('afterend', injectedHTML);
  };

  const removeIfNeeded = () => {
    const injected = getInjected();
    if (injected) injected.remove();
  };

  const sync = () => {
    if (hasSellingPlanValue()) {
      injectIfNeeded();
      addSubsClass();
    } else {
      removeIfNeeded();
      removeSubsClass();
    }
  };

  // Wait until Skio mounts
  let attempts = 0;
  const poll = setInterval(() => {
    attempts++;
    if (getSellingPlanInput() && getInsertAfterEl()) {
      clearInterval(poll);
      sync();
      attachObservers();
    }
    if (attempts > 200) clearInterval(poll);
  }, 100);

  function attachObservers() {
    const sellingPlan = getSellingPlanInput();

    // Observe attribute changes
    const valueObserver = new MutationObserver(sync);
    valueObserver.observe(sellingPlan, { attributes: true, attributeFilter: ['value'] });

    // Catch programmatic .value changes
    let last = sellingPlan.value;
    setInterval(() => {
      if (sellingPlan.value !== last) {
        last = sellingPlan.value;
        sync();
      }
    }, 150);

    // Re-sync if Skio re-renders DOM
    const domObserver = new MutationObserver(sync);
    domObserver.observe(document.documentElement, { childList: true, subtree: true });

    sync();
    requestAnimationFrame(sync);
    setTimeout(sync, 50);
    setTimeout(sync, 200);
  }
})();




/*crossed out price skio*/
(function () {
  const SUB_PRICE_SEL = 'span[skio-subscription-price]';
  const ONE_TIME_SEL  = 'span[skio-onetime-price]';
  const CROSSED_CLASS = 'crossed_price';

  const getSubEl = () => document.querySelector(SUB_PRICE_SEL);
  const getOneTimeEl = () => document.querySelector(ONE_TIME_SEL);

  const upsertCrossedPrice = () => {
    const subEl = getSubEl();
    const oneTimeEl = getOneTimeEl();
    if (!subEl || !oneTimeEl) return;

    const oneTimeText = (oneTimeEl.textContent || '').trim();
    if (!oneTimeText) return;

    // Find existing crossed price right next to subscription price
    let crossed = subEl.parentElement?.querySelector(`.${CROSSED_CLASS}`);
    if (!crossed || crossed.nextElementSibling !== subEl) {
      // Create / re-place it so it always sits directly LEFT of the sub price
      crossed = document.createElement('span');
      crossed.className = CROSSED_CLASS;
      crossed.style.marginRight = '8px';
      crossed.style.textDecoration = 'line-through';
      crossed.style.opacity = '0.7';
      subEl.insertAdjacentElement('beforebegin', crossed);
    }

    // Keep it updated to onetime price
    if ((crossed.textContent || '').trim() !== oneTimeText) {
      crossed.textContent = oneTimeText;
      // console.log('[Skio] Crossed price set to:', oneTimeText);
    }
  };

  // Initial tries (Skio often mounts late)
  upsertCrossedPrice();
  requestAnimationFrame(upsertCrossedPrice);
  setTimeout(upsertCrossedPrice, 50);
  setTimeout(upsertCrossedPrice, 200);

  // Observe the DOM for Skio updates / re-renders
  const domObserver = new MutationObserver(() => {
    upsertCrossedPrice();
  });

  domObserver.observe(document.documentElement, {
    childList: true,
    subtree: true,
    characterData: true
  });

  // Also watch price text changes directly (if elements already exist)
  const attachPriceObservers = () => {
    const oneTimeEl = getOneTimeEl();
    const subEl = getSubEl();
    if (!oneTimeEl || !subEl) return false;

    const priceObserver = new MutationObserver(() => upsertCrossedPrice());
    priceObserver.observe(oneTimeEl, { childList: true, subtree: true, characterData: true });
    priceObserver.observe(subEl, { childList: true, subtree: true, characterData: true });

    return true;
  };

  // Try attaching direct observers until available
  let tries = 0;
  const poll = setInterval(() => {
    tries++;
    if (attachPriceObservers()) clearInterval(poll);
    if (tries > 200) clearInterval(poll);
  }, 100);
})();






(function () {
  const imgSelector = '.candyrack-ppp-image-wrapper img';
  const currencySelector = '.candyrack-ppp-currency-output';

  const updateImg = (img) => {
    if (img.src && img.src.includes('_small')) {
      img.src = img.src.replace('_small', '');
    }
  };

  const updateCurrency = (el) => {
    if (el.textContent.includes('USD')) {
      el.textContent = el.textContent.replace(/\s*USD\s*/g, '').trim();
    }
  };

  const processAll = () => {
    // Images
    document.querySelectorAll(imgSelector).forEach(img => {
      if (img.complete) {
        updateImg(img);
      } else {
        img.addEventListener('load', () => updateImg(img), { once: true });
      }
    });

    // Currency text
    document.querySelectorAll(currencySelector).forEach(updateCurrency);
  };

  // Initial run
  processAll();

  // Observe DOM changes (Candyrack injects dynamically)
  const observer = new MutationObserver(processAll);

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
})();




/*only one cart dom on mobile*/
(function () {
  const selector = 'drawer-component#Drawer-Cart[open]';

  const enforceSingleOpenDrawer = () => {
    const openDrawers = document.querySelectorAll(selector);

    if (openDrawers.length <= 1) return;

    openDrawers.forEach((drawer, index) => {
      if (index === 0) return; // keep first one open

      drawer.removeAttribute('open');
      drawer.setAttribute('hidden', '');
      drawer.setAttribute('aria-hidden', 'true');

      console.warn('[Drawer] Extra open drawer closed:', drawer);
    });
  };

  // Run once initially
  enforceSingleOpenDrawer();

  // Watch for Shopify/theme re-injections
  const observer = new MutationObserver(enforceSingleOpenDrawer);

  observer.observe(document.body, {
    attributes: true,
    subtree: true,
    attributeFilter: ['open']
  });
})();




/* add subheading for pairs well with*/


(() => {
  const TITLE_SEL = ".lb-card-title.lb-title-ld";
  const SUB_CLASS = "lb-card-subheading-ecd";

  const TITLE_TO_SUB = {
  "Texture Renewal Duo": "Oil Control & Pore Care Set",
  "Radiance Glow Ritual": "Pigmentation & Brightening TRIO",
  "Deep Hydra Revival Duo": "Dry Skin Moisture Boost Set",
  "Timeless Youth Ritual": "RENEWING TRIO",
  "Age-Defying 3-Zone Ritual": "Eyes, Face, Neck & Décolleté",
  "100% Silk Headband": "for Skincare & Makeup",
  "Stainless steel Gua-Sha": "Skincare tool for facial massage",
  "HydroTone+": "Hydrating & Soothing Toner",
  "HydroClean+": "Moisturising Cleanser",
  "Décolletage+": "Firming Care for Neck & Chest",
  "CelluFirm+": "Cellulite Cream",
  "BodySculpt+": "Firming Body Cream",
  "BodySilk+": "Restorative Body Oil",
  "DeepRepair+": "Restoring Face Cream",
  "PureGlow+": "Restorative Face Oil",
  "NiacinB3+": "Balancing Niacinamide Serum",
  "DayShield+": "Protecting Day Cream with SPF30",
  "EyeLift+": "Renewing Eye Cream",
  "EyeGlow+": "Eye Brightening Cream",
  "SuperLift+": "Anti-Aging All-in-One Serum",
  "Retin-A+": "Renewing Retinol Serum",
  "C-Bright+": "Vitamin C + B + E Ferulic Serum",
  "HydroBlue+": "Hydrating Hyaluronic Acid Serum",
  "Restoring Face Cream": "DeepRepair+",
  "Hyaluronic Acid Serum": "HydroBlue+",
  "Illuminating Face Serum": "C-Bright+"
};

  const applySubheading = (titleEl) => {
    if (!titleEl) return;

    const titleText = titleEl.textContent.trim();
    const subText = TITLE_TO_SUB[titleText];
    if (!subText) return;

    const container =
      titleEl.closest(".lb-card-title-cont") || titleEl.parentElement;
    if (!container) return;

    // prevent duplicates
    let sub = container.querySelector(`.${SUB_CLASS}`);
    if (!sub) {
      sub = document.createElement("div");
      sub.className = SUB_CLASS;
      titleEl.insertAdjacentElement("afterend", sub);
    }

    sub.textContent = subText;
  };

  const scan = (root = document) => {
    root.querySelectorAll(TITLE_SEL).forEach(applySubheading);
  };

  // styling (safe + minimal)
  const injectStyles = () => {
    if (document.getElementById("lb-subheading-style-ecd")) return;

    const style = document.createElement("style");
    style.id = "lb-subheading-style-ecd";
    style.textContent = `
      .${SUB_CLASS} {
        margin-top: 0px;
        font-size: 12px;
        line-height: 1.3;
        opacity: 0.8;
      }
    `;
    document.head.appendChild(style);
  };

  const observe = () => {
    const observer = new MutationObserver((mutations) => {
      mutations.forEach((m) => {
        if (m.type === "childList") {
          m.addedNodes.forEach((node) => {
            if (!(node instanceof Element)) return;

            if (node.matches?.(TITLE_SEL)) {
              applySubheading(node);
            } else if (node.querySelector?.(TITLE_SEL)) {
              scan(node);
            }
          });
        }
      });
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true
    });

    scan();
  };

  injectStyles();

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", observe, { once: true });
  } else {
    observe();
  }
})();




(function() {
  function applyOverride() {
    const crossed = document.querySelector('.crossed_price');
    if (!crossed) return;

    crossed.style.display = 'inline-block';

    // Only read compare-at from the MAIN product price block. A global selector
    // also matches on-sale cards elsewhere on the page (e.g. recommendations at
    // $79), which caused the wrong crossed-out price when the current product
    // has no sale.
    const mainPriceEl = document.querySelector('.f-product-single__blocks .f-price.f-price--on-sale');
    const themeCompare = mainPriceEl?.querySelector('s.f-price-item--regular');

    if (!mainPriceEl || !themeCompare) {
      // Main product is not on sale — keep Skio one-time text with strikethrough.
      crossed.style.textDecoration = 'line-through';
      crossed.style.fontSize = '';
      crossed.style.lineHeight = '';
      crossed.removeAttribute('data-override-price');
      return;
    }

    const TARGET_DISPLAY = themeCompare.textContent.trim();
    if (!TARGET_DISPLAY) return;

    crossed.style.textDecoration = 'none';
    crossed.style.fontSize = '0';
    crossed.style.lineHeight = '0';
    crossed.setAttribute('data-override-price', TARGET_DISPLAY);

    if (!document.querySelector('#skio-price-override-style')) {
      const style = document.createElement('style');
      style.id = 'skio-price-override-style';
      style.textContent = `
        .crossed_price[data-override-price]::after {
          content: attr(data-override-price);
          font-size: 1.5rem;
          line-height: normal;
          text-decoration: line-through;
          opacity: 0.7;
        }
      `;
      document.head.appendChild(style);
    }
  }

  function init() {
    // Run eagerly on DOM mutations so it fires even when Skio mounts late,
    // and re-runs on variant switches to clear stale overrides.
    let lastRun = 0;
    const obs = new MutationObserver(() => {
      const now = Date.now();
      if (now - lastRun < 200) return;
      lastRun = now;
      applyOverride();
    });
    obs.observe(document.documentElement, { childList: true, subtree: true, characterData: true });

    applyOverride();
    requestAnimationFrame(applyOverride);
    setTimeout(applyOverride, 100);
    setTimeout(applyOverride, 300);
    setTimeout(applyOverride, 500);
    setTimeout(applyOverride, 1000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();




(function () {
  var MEDIA_SELECTOR = '.f-product__media--video';

  function forcePlayVideo(videoEl) {
    if (!videoEl) return;
    videoEl.muted = true;
    videoEl.playsInline = true;
    videoEl.setAttribute('playsinline', '');
    videoEl.setAttribute('muted', '');
    videoEl.removeAttribute('controls');
    videoEl.controls = false;

    // Override preload so iOS actually buffers
    if (videoEl.preload === 'none') {
      videoEl.preload = 'auto';
    }

    // Force load then play
    var attemptPlay = function () {
      var p = videoEl.play();
      if (p && typeof p.catch === 'function') {
        p.catch(function () {
          // Retry after a tick — iOS sometimes needs this
          setTimeout(function () {
            videoEl.play().catch(function () {});
          }, 500);
        });
      }
    };

    if (videoEl.readyState >= 2) {
      attemptPlay();
    } else {
      videoEl.load();
      videoEl.addEventListener('canplay', attemptPlay, { once: true });
    }
  }

  function pauseVideo(videoEl) {
    if (videoEl && !videoEl.paused) {
      videoEl.pause();
    }
  }

  function ensureDeferredMediaLoaded(mediaSlide) {
    var deferred = mediaSlide.querySelector('deferred-media');
    if (!deferred) return;

    // If there's still a <template> with a video inside, the deferred-media
    // hasn't been "opened" yet — simulate the poster click to inject the video
    var tpl = deferred.querySelector('template');
    if (tpl && tpl.content && tpl.content.querySelector('video')) {
      var poster = deferred.querySelector('.deferred-media__poster');
      if (poster) {
        poster.click(); // triggers the theme's built-in template → DOM swap
      }
    }
  }

  function handleSlideChange(flickityEl, index) {
    var slides = flickityEl.querySelectorAll('.f-product__media');
    slides.forEach(function (slide, i) {
      var video = slide.querySelector('video');
      if (slide.getAttribute('data-media-type') === 'video') {
        if (i === index) {
          ensureDeferredMediaLoaded(slide);
          // Small delay to let deferred-media inject the <video> if needed
          setTimeout(function () {
            var v = slide.querySelector('video');
            forcePlayVideo(v);
          }, 150);
        } else {
          pauseVideo(video);
        }
      }
    });
  }

  function init() {
    var flickityEl = document.querySelector('flickity-component.f-product__media-list');
    if (!flickityEl) return;

    // Wait for Flickity to be initialized
    var waitForFlickity = setInterval(function () {
      var flkty = Flickity.data(flickityEl);
      if (!flkty) return;
      clearInterval(waitForFlickity);

      // On slide change — play video if landing on one, pause if leaving
      flkty.on('change', function (index) {
        handleSlideChange(flickityEl, index);
      });

      // Also handle settle (after drag/flick animation completes — more reliable on iOS)
      flkty.on('settle', function (index) {
        handleSlideChange(flickityEl, index);
      });

      // Handle initial state if video happens to be the first slide
      handleSlideChange(flickityEl, flkty.selectedIndex);
    }, 200);

    // Safety: clear the interval after 10s if Flickity never shows up
    setTimeout(function () { clearInterval(waitForFlickity); }, 10000);
  }

  // Also observe for late-injected videos (deferred-media pattern)
  var observer = new MutationObserver(function (mutations) {
    mutations.forEach(function (m) {
      m.addedNodes.forEach(function (node) {
        if (node.nodeType !== 1) return;
        if (node.tagName === 'VIDEO') {
          var parentSlide = node.closest('.f-product__media--video.is-selected');
          if (parentSlide) forcePlayVideo(node);
        }
        if (node.querySelectorAll) {
          node.querySelectorAll('.f-product__media--video.is-selected video').forEach(forcePlayVideo);
        }
      });
    });
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      init();
      observer.observe(document.body, { childList: true, subtree: true });
    });
  } else {
    init();
    observer.observe(document.body, { childList: true, subtree: true });
  }
})();





(function() {
  const CORRECT_FORM_ID = 'product-form-template--25217705509194__main';

  function fixFormAssociation() {
    const sellingPlan = document.querySelector('input[name="selling_plan"]');
    const discount = document.querySelector('input[name="properties[Discount]"]');
    let changed = false;

    if (sellingPlan && sellingPlan.getAttribute('form') !== CORRECT_FORM_ID) {
      sellingPlan.setAttribute('form', CORRECT_FORM_ID);
      changed = true;
    }
    if (discount && discount.getAttribute('form') !== CORRECT_FORM_ID) {
      discount.setAttribute('form', CORRECT_FORM_ID);
      changed = true;
    }
    return changed;
  }

  // Run immediately + on DOM ready + poll briefly to beat Skio init
  fixFormAssociation();
  document.addEventListener('DOMContentLoaded', fixFormAssociation);

  let tries = 0;
  const poll = setInterval(() => {
    fixFormAssociation();
    if (++tries > 40) clearInterval(poll);
  }, 50);

  // Keep the observer for later mutations
  const picker = document.querySelector('[skio-plan-picker]');
  if (picker) {
    new MutationObserver(fixFormAssociation)
      .observe(picker, { attributes: true, subtree: true, attributeFilter: ['form'] });
  }
})();